import React from "react";
import { Plus, Trash2 } from "lucide-react";

const DAYS = [
  { value: "monday", label: "Lundi" },
  { value: "tuesday", label: "Mardi" },
  { value: "wednesday", label: "Mercredi" },
  { value: "thursday", label: "Jeudi" },
  { value: "friday", label: "Vendredi" },
  { value: "saturday", label: "Samedi" },
  { value: "sunday", label: "Dimanche" },
];

const emptySlot = () => ({ day: "wednesday", startTime: "17:00", endTime: "18:00", room: "Salle de danse", teacherId: "", teacher: "" });

const SlotsEditor = ({ value, onChange, teachers = [] }) => {
  const slots = Array.isArray(value) ? value : [];

  const update = (idx, patch) => {
    const next = slots.map((s, i) => (i === idx ? { ...s, ...patch } : s));
    onChange(next);
  };
  const setTeacher = (idx, teacherId) => {
    const t = teachers.find((x) => x.id === teacherId);
    update(idx, { teacherId, teacher: t?.name || "" });
  };
  const add = () => onChange([...slots, emptySlot()]);
  const remove = (idx) => onChange(slots.filter((_, i) => i !== idx));

  return (
    <div data-testid="slots-editor" className="space-y-2">
      {slots.length === 0 && (
        <div className="text-stone-500 text-xs italic">Aucun créneau. Cliquez sur « Ajouter un créneau » pour planifier ce cours sur la semaine.</div>
      )}
      {slots.map((s, idx) => (
        <div key={idx} className="grid grid-cols-2 sm:grid-cols-6 gap-2 bg-stone-50 border border-stone-200 rounded-lg p-2.5">
          <select
            value={s.day || "wednesday"}
            onChange={(e) => update(idx, { day: e.target.value })}
            data-testid={`slot-day-${idx}`}
            className="col-span-2 bg-white border border-stone-200 rounded px-2 py-1.5 text-sm"
          >
            {DAYS.map((d) => <option key={d.value} value={d.value}>{d.label}</option>)}
          </select>
          <input
            type="time"
            value={s.startTime || ""}
            onChange={(e) => update(idx, { startTime: e.target.value })}
            data-testid={`slot-start-${idx}`}
            className="bg-white border border-stone-200 rounded px-2 py-1.5 text-sm"
          />
          <input
            type="time"
            value={s.endTime || ""}
            onChange={(e) => update(idx, { endTime: e.target.value })}
            data-testid={`slot-end-${idx}`}
            className="bg-white border border-stone-200 rounded px-2 py-1.5 text-sm"
          />
          <select
            value={s.teacherId || (s.teacher ? (teachers.find((t) => t.name === s.teacher)?.id || "") : "")}
            onChange={(e) => setTeacher(idx, e.target.value)}
            data-testid={`slot-teacher-${idx}`}
            className="bg-white border border-stone-200 rounded px-2 py-1.5 text-sm"
          >
            <option value="">— Prof —</option>
            {teachers.map((t) => <option key={t.id} value={t.id}>{t.name}</option>)}
          </select>
          <div className="flex gap-1">
            <input
              type="text"
              value={s.room || ""}
              onChange={(e) => update(idx, { room: e.target.value })}
              placeholder="Salle"
              className="flex-1 bg-white border border-stone-200 rounded px-2 py-1.5 text-sm min-w-0"
            />
            <button onClick={() => remove(idx)} data-testid={`slot-remove-${idx}`} className="p-1.5 rounded bg-red-50 hover:bg-red-100 text-red-600">
              <Trash2 size={14}/>
            </button>
          </div>
        </div>
      ))}
      <button
        type="button"
        onClick={add}
        data-testid="slot-add-button"
        className="inline-flex items-center gap-1.5 text-xs text-deep-rose hover:underline mt-1"
      >
        <Plus size={14}/> Ajouter un créneau
      </button>
      {teachers.length === 0 && (
        <div className="text-xs text-amber-700 mt-1">Aucun professeur dans la base. Créez-les d&apos;abord dans le menu « Professeurs ».</div>
      )}
    </div>
  );
};

export default SlotsEditor;
